import logger from '@/modules/Logger';
import { buildJoinMeta, joinPrefix } from '@/modules/webrtc/joinLogUtils';

export default {
  // initialize and join a channel
  async join(lessonId) {
    let peerId = null;
    let stream = null;

    // channel name should be string
    this.channelName = String(lessonId);

    logger.info(
      `${joinPrefix('Agora')} Join started - channel: ${this.channelName}, userId: ${this.userId}`,
      buildJoinMeta({ provider: 'agora', lessonId })
    );

    this.configureAgoraLogs();
    this.setEventListener();

    // enable dual-stream mode (high/low quality stream)
    await this.enableDualStream();

    peerId = await this.joinChannel()
      .then(async () => (await this.setDeviceAvailability()))
      .then(async () => (stream = await this.publishStreamToChannel()));

    let rtc = this.rtc;

    return { peerId, stream, rtc };
  }
}
